import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_DELIVERIES,
  CLEAR_DELIVERY,
  CLEAR_YANGO_CANCELATION_INFO,
  CLEAR_YANGO_PRICE,
  FLAG_DELIVERY_ACTIVITY,
  FLAG_GETTING_DELIVERIES,
  FLAG_YANGO_DELIVERY_ACTIVITY,
  GET_DELIVERIES,
  GET_DELIVERY,
  GET_YANGO_CANCELATION_INFO,
  GET_YANGO_CLAIM,
  GET_YANGO_PRICE,
  OPEN_MODAL,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
  modal: false,
  yango: Immutable.Map({
    price: Immutable.Map(),
    activity: Immutable.List(),
    cancelation: Immutable.Map(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_DELIVERIES:
      return state.setIn(['all', 'loading'], payload);
    case GET_DELIVERIES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_DELIVERIES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_DELIVERY_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_DELIVERY:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_DELIVERY:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    case OPEN_MODAL:
      return state.set('modal', payload);
    case FLAG_YANGO_DELIVERY_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['yango', 'activity'],
          state.getIn(['yango', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['yango', 'activity'],
        state.getIn(['yango', 'activity']).pop(),
      );
    case GET_YANGO_PRICE:
      return state.setIn(['yango', 'price'], Immutable.Map(payload));
    case CLEAR_YANGO_PRICE:
      return state.setIn(
        ['yango', 'price'],
        INITIAL_STATE.getIn(['yango', 'price']),
      );
    case GET_YANGO_CLAIM:
      return state.setIn(['current', 'content', 'yangoDeliveryClaim'], payload);
    case GET_YANGO_CANCELATION_INFO:
      return state.setIn(['yango', 'cancelation'], Immutable.Map(payload));
    case CLEAR_YANGO_CANCELATION_INFO:
      return state.setIn(
        ['yango', 'cancelation'],
        INITIAL_STATE.getIn(['yango', 'cancelation']),
      );
    default:
      return state;
  }
};
